import React from 'react';
import classNames from 'classnames';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    iframeUrl,
    iframeHeight,
    iframeWidth,
    ampLayout,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  } = this.props; // eslint-disable-line

  return (
    <div
      className={classNames({
        [`${cssPrefix}__iframe`]: loadStyles,
        ...extraClassNames,
      })}
    >
      <amp-iframe
        width={parseInt(iframeWidth, 10)}
        height={parseInt(iframeHeight, 10)}
        layout={ampLayout}
        frameborder="0"
        src={iframeUrl}
      />
    </div>
  );
}

export default renderAmp;
